import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { CONTENT_TYPE } from "../constants/conf";

var beaconRequest = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url, data) {
    var headers, body;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            headers = {
              type: CONTENT_TYPE
            };
            body = new Blob([data], headers);

            if (navigator.sendBeacon(url, body)) {
              _context.next = 4;
              break;
            }

            throw new Error('Send beacon fail.');

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function beaconRequest(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

export default beaconRequest;